"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _hexRgb2 = _interopRequireDefault(require("hex-rgb"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @deprecated use `rgb` or `rgba` from `polished` instead - https://polished.js.org/docs/#rgb
 */
var _default = function _default(hex, alpha) {
  var _hexRgb = (0, _hexRgb2["default"])(hex),
      red = _hexRgb.red,
      green = _hexRgb.green,
      blue = _hexRgb.blue;

  return alpha ? "rgba(".concat(red, ", ").concat(green, ", ").concat(blue, ", ").concat(alpha, ")") : "rgb(".concat(red, ", ").concat(green, ", ").concat(blue, ")");
};

exports["default"] = _default;